/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { Card, Table, Checkbox, Typography, Row, Col, Spin, message, Alert } from 'antd';
import { DollarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { settlementAPI, organisationAPI } from '../../../services/api';
import moment from 'moment';

const { Title, Text } = Typography;

// Step 2: Transaction Summary
// - Loads organisation commission types for selected beneficiary
// - Builds a channel list and allows toggling "included"
// - Totals are computed from included non-zero channels
// - Parent state receives the FULL channels list but amounts from included only
const Step2TransactionSummary = ({ data, onDataChange }) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [channels, setChannels] = useState([]);
  const [senderOrgs, setSenderOrgs] = useState([]);
  const [beneficiaryOrgs, setBeneficiaryOrgs] = useState([]);
  const [totals, setTotals] = useState({
    grossAmount: 0,
    totalFees: 0,
    totalVAT: 0,
    netAmount: 0,
    netSettlement: 0
  });

  // Helper functions for formatting with commas
  const formatAmount5 = (value) => {
    return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 });
  };
  const formatAmount2 = (value) => {
    return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Load orgs to be able to display names based on selected IDs (non-blocking)
  useEffect(() => {
    const loadOrgs = async () => {
      try {
        const [sendersRes, beneficiariesRes] = await Promise.all([
          organisationAPI.getSettlementOrganisations('my_company'),
          organisationAPI.getSettlementOrganisations('pto')
        ]);

        const senders = Array.isArray(sendersRes.data?.data?.organisations) ? sendersRes.data.data.organisations : [];
        const beneficiaries = Array.isArray(beneficiariesRes.data?.data?.organisations) ? beneficiariesRes.data.data.organisations : [];
        setSenderOrgs(senders);
        setBeneficiaryOrgs(beneficiaries);
      } catch (e) {
        // Non-blocking for the screen; names will fallback to channel/org data
        // console.warn('Failed to load orgs for display names', e);
      }
    };

    loadOrgs();
  }, []);

  useEffect(() => {
    if (data.status && data.status !== 'Draft' && data.id) {
      // Read-only view for existing settlement: synthesize included rows using known totals
      const amount = Math.abs(Number(data.amount) || 0);
      const fees = Number(data.fees_amount) || 0;
      const vat = Number(data.tax_amount) || 0;
      const synthetic = [{
        id: 'summary',
        channel: 'Included (Summary)',
        grossAmount: amount + fees + vat,
        fees,
        vat,
        netAmount: amount,
        ourBank: false,
        included: true,
        transactionCount: 0,
      }];
      setChannels(synthetic);
      calculateTotals(synthetic);
      // Update parent data but do not override other fields
      onDataChange({ channels: synthetic, fees_amount: fees, tax_amount: vat, amount: data.amount });
      return; // Do not fetch from API
    }

    if (data.sender_id && data.beneficiary_id && data.settlement_from_date && data.settlement_till_date) {
      if (data.channels && data.channels.length > 0) {
        setChannels(data.channels);
        calculateTotals(data.channels);
      } else {
        loadTransactionSummary();
      }
    }
  }, [data.status, data.id, data.amount, data.fees_amount, data.tax_amount, data.sender_id, data.beneficiary_id, data.settlement_from_date, data.settlement_till_date]);

  const loadTransactionSummary = async () => {
    try {
      setLoading(true);

      // Get organization commission types with aggregated transaction data, filtered by selected period
      const response = await settlementAPI.getOrganisationCommissionTypes(
        data.beneficiary_id,
        {
          till_date: data.settlement_till_date
        }
      );

      // console.debug('Commission types response:', response);

      const commissionTypes = response.data?.data?.organisationCommissionTypes || [];

      // Transform API data to match table structure
      const channelsData = commissionTypes.map(ct => {
        // Check if we have existing selection for this channel
        const existingChannel = data.channels?.find(existing => existing.id === ct.org_com_id);

        return {
          id: ct.org_com_id,
          channel: ct.com_type_en_name || ct.com_type_ar_name,
          grossAmount: parseFloat(ct.total_paid_amount_sum) || 0,
          fees: parseFloat(ct.total_fees_sum) || 0,
          vat: parseFloat(ct.total_vat_sum) || 0,
          netAmount: parseFloat(ct.sum_amount_tobe_settled) || 0, // Use sum_amount_tobe_settled as net
          ourBank: ct.our_bank || false,
          // Preserve existing selection or default to false
          included: existingChannel ? existingChannel.included : false,
          transactionCount: parseInt(ct.transaction_count) || 0,
          organisationName: ct.org_en_name || '', // Add organization name
          commissionTypeId: ct.organisations_commission_type_id || ct.org_com_id,
          // Store all available data for reference
          rawData: {
            total_fees_sum: ct.total_fees_sum,
            total_vat_sum: ct.total_vat_sum,
            total_amount_sum: ct.total_amount_sum,
            total_paid_amount_sum: ct.total_paid_amount_sum,
            sum_amount_tobe_settled: ct.sum_amount_tobe_settled,
            transaction_count: ct.transaction_count,
            org_en_name: ct.org_en_name,
            com_ar_name: ct.com_ar_name,
            com_en_name: ct.com_en_name
          }
        };
      });

      setChannels(channelsData);
      calculateTotals(channelsData);

      // Update parent data - send FULL channels list with included flags.
      // Amounts are still calculated from included channels only.
      onDataChange({
        channels: channelsData,
        ...calculateAmounts(channelsData)
      });

    } catch (error) {
      message.error(intl.formatMessage({ id: 'settlement_FailedToLoadTransactionData' }, { summary: error.response?.data?.message || error.message }));
    } finally {
      setLoading(false);
    }
  };

  const calculateAmounts = (channelsData) => {
    const includedChannels = channelsData.filter(c => c.included && c.netAmount !== 0);

    // Compute diffs: OurBank(true) - OurBank(false)
    const ourBankAmount = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.netAmount, 0);

    const theirBankAmount = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.netAmount, 0);

    const netSettlement = ourBankAmount - theirBankAmount;

    const ourBankFees = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.fees, 0);
    const theirBankFees = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.fees, 0);
    const diffFees = ourBankFees - theirBankFees;
    const totalFees = ourBankFees + theirBankFees; // Sum for totals display

    const ourBankVAT = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.vat, 0);
    const theirBankVAT = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.vat, 0);
    const diffVAT = ourBankVAT - theirBankVAT;
    const totalVAT = ourBankVAT + theirBankVAT; // Sum for totals display

    return {
      fees_amount: totalFees,  // Send summed fees instead of difference
      tax_amount: totalVAT,    // Send summed VAT instead of difference
      amount: netSettlement,
      summed_fees: totalFees,
      summed_vat: totalVAT
    };
  };

  const calculateTotals = (channelsData) => {
    const includedChannels = channelsData.filter(c => c.included && c.netAmount !== 0);

    // Compute diffs (OurBank(true) - OurBank(false)) for each component
    const ourBankGross = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.grossAmount, 0);
    const theirBankGross = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.grossAmount, 0);
    const grossAmount = ourBankGross - theirBankGross;

    const ourBankFees = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.fees, 0);
    const theirBankFees = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.fees, 0);
    const diffFees = ourBankFees - theirBankFees;
    const totalFees = ourBankFees + theirBankFees; // Sum for totals display

    const ourBankVAT = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.vat, 0);
    const theirBankVAT = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.vat, 0);
    const diffVAT = ourBankVAT - theirBankVAT;
    const totalVAT = ourBankVAT + theirBankVAT; // Sum for totals display

    const ourBankAmount = includedChannels
      .filter(c => c.ourBank)
      .reduce((sum, c) => sum + c.netAmount, 0);

    const theirBankAmount = includedChannels
      .filter(c => !c.ourBank)
      .reduce((sum, c) => sum + c.netAmount, 0);

    const netAmount = includedChannels.reduce((sum, c) => sum + c.netAmount, 0);
    const netSettlement = ourBankAmount - theirBankAmount;

    setTotals({
      grossAmount,
      totalFees,
      totalVAT,
      netAmount,
      netSettlement
    });
  };

  // Toggle "included" per channel and recompute totals + amounts
  const handleChannelToggle = (channelId, included) => {
    const updatedChannels = channels.map(channel =>
      channel.id === channelId ? { ...channel, included } : channel
    );

    setChannels(updatedChannels);
    calculateTotals(updatedChannels);

    // Update parent data - send FULL channels list with included flags.
    onDataChange({
      channels: updatedChannels,
      ...calculateAmounts(updatedChannels)
    });
  };

  const columns = [
    {
      title: intl.formatMessage({ id: 'settlement_Channel' }),
      dataIndex: 'channel',
      key: 'channel',
      width: 180,
    },
    {
      title: intl.formatMessage({ id: 'settlement_Transactions' }),
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      align: 'center',
      width: 100,
      render: (value, record) => {
        if (record.key === 'totals') {
          return '';
        }
        return value || 0;
      },
    },
    {
      title: intl.formatMessage({ id: 'settlement_GrossAmount' }),
      dataIndex: 'grossAmount',
      key: 'grossAmount',
      align: 'right',
      width: 120,
      render: (value, record) => {
        if (record.key === 'totals') {
          return '';
        }
        return `${value} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`;
      },
    },
    {
      title: intl.formatMessage({ id: 'settlement_Fees' }),
      dataIndex: 'fees',
      key: 'fees',
      align: 'right',
      width: 100,
      render: (value, record) => {
        if (record.key === 'totals') {
          return <strong style={{ color: '#52c41a' }}>{`${formatAmount5(value)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`}</strong>;
        }
        return `${formatAmount5(value)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`;
      },
    },
    {
      title: intl.formatMessage({ id: 'settlement_VAT' }),
      dataIndex: 'vat',
      key: 'vat',
      align: 'right',
      width: 100,
      render: (value, record) => {
        if (record.key === 'totals') {
          return <strong style={{ color: '#52c41a' }}>{`${formatAmount5(value)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`}</strong>;
        }
        return `${formatAmount5(value)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`;
      },
    },
    {
      title: intl.formatMessage({ id: 'settlement_AmountToSettle' }),
      dataIndex: 'netAmount',
      key: 'netAmount',
      align: 'right',
      width: 130,
      render: (value, record) => {
        if (record.key === 'totals') {
          return <strong style={{ color: '#1890ff' }}>{`${formatAmount2(value)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`}</strong>;
        }
        // UI-only: show minus sign for non-ourBank rows
        const isNegativeDisplay = record.ourBank === false && value !== 0;
        const displayText = isNegativeDisplay
          ? `- ${formatAmount2(Math.abs(Number(value)))} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`
          : `${formatAmount2(value)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}`;
        return <strong>{displayText}</strong>;
      },
    },
    {
      title: intl.formatMessage({ id: 'settlement_OurBank' }),
      dataIndex: 'ourBank',
      key: 'ourBank',
      align: 'center',
      width: 100,
      render: (value, record) => {
        if (record.key === 'totals') return '';
        return value ? intl.formatMessage({ id: 'settlement_Yes' }) : intl.formatMessage({ id: 'settlement_No' });
      }
    },
    {
      title: intl.formatMessage({ id: 'settlement_Include' }),
      dataIndex: 'included',
      key: 'included',
      align: 'center',
      width: 80,
      render: (value, record) => {
        if (record.key === 'totals') return '';
        const readOnly = data.status && data.status !== 'Draft' && data.id;
        if (readOnly) return value ? 'Yes' : 'No';
        return (
          <Checkbox
            checked={value}
            onChange={(e) => handleChannelToggle(record.id, e.target.checked)}
          />
        );
      },
    },
  ];

  // Create totals row data (calculated from included non-zero channels)
  // Note: VAT and Fees show SUMMED values (ourBank + theirBank) instead of difference
  const totalsRowData = {
    key: 'totals',
    channel: intl.formatMessage({ id: 'settlement_Total' }),
    grossAmount: undefined,
    fees: totals.totalFees, // Show summed fees in totals
    vat: totals.totalVAT,   // Show summed VAT in totals
    netAmount: totals.netSettlement
  };

  // Simpler table data: non-zero channels first, then zero-net channels, then totals
  const tableRows = [...channels].sort((a, b) => (a.netAmount === 0) - (b.netAmount === 0));
  const tableData = [...tableRows, totalsRowData];

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px' }}>{intl.formatMessage({ id: 'settlement_LoadingTransactions' })}</div>
      </div>
    );
  }

  const getSenderName = () => {
    if (data.sender_name) return data.sender_name;
    const found = senderOrgs.find(o => o.id === data.sender_id);
    return found?.en_name || found?.name || '';
  };

  const getBeneficiaryName = () => {
    if (data.beneficiary_name) return data.beneficiary_name;
    const found = beneficiaryOrgs.find(o => o.id === data.beneficiary_id);
    if (found) return found.en_name || found.name || '';
    // Fallback: use organisationName provided in channels (comes from the API for beneficiary)
    return channels[0]?.organisationName || '';
  };

  const fmtDate = (val) => {
    if (!val) return '';
    try {
      // Display-only: DD-MM-YYYY
      return moment(val).format('DD-MM-YYYY');
    } catch (error) {
      console.warn('Date formatting error in Step2:', error, val);
      return val;
    }
  };

  const getSettlementTypeName = () => {
    // Prefer the name captured in Step 1
    if (data.settlement_type_name) return data.settlement_type_name;
    return '';
  };

  return (
    <div className="step2-transaction-summary">
      <Card>
        <Title level={4}>
          <DollarOutlined /> {intl.formatMessage({ id: 'settlement_TransactionSummaryTitle' })}
        </Title>

        <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
          <Col xs={24} md={6}>
            <Card size="small">
              <Text strong>{intl.formatMessage({ id: 'settlement_SettlementTypeLabel' })}</Text> {getSettlementTypeName()}
            </Card>
          </Col>
          <Col xs={24} md={6}>
            <Card size="small">
              <Text strong>{intl.formatMessage({ id: 'settlement_SenderOurCompanyLabel' })}</Text> {getSenderName()}
            </Card>
          </Col>
          <Col xs={24} md={6}>
            <Card size="small">
              <Text strong>{intl.formatMessage({ id: 'settlement_BeneficiaryLabel' })}</Text> {getBeneficiaryName()}
            </Card>
          </Col>
          <Col xs={24} md={6}>
            <Card size="small">
              <Text strong>{intl.formatMessage({ id: 'settlement_PeriodLabelShort' })}</Text>
              <div>{fmtDate(data.settlement_from_date)} - </div>
              <div>{fmtDate(data.settlement_till_date)} </div>
            </Card>
          </Col>
        </Row>

        <Title level={5}>{intl.formatMessage({ id: 'settlement_SelectChannelsToInclude' })}</Title>

        <Table
          columns={columns}
          dataSource={tableData}
          rowKey={(record) => record.key || record.id}
          pagination={false}
          size="middle"
          style={{ marginBottom: '24px' }}
          rowClassName={(record) => record.key === 'totals' ? 'totals-row' : ''}
        />

        <style jsx>{`
          .totals-row {
            background-color: #f0f0f0 !important;
            font-weight: bold;
            border-top: 2px solid #d9d9d9;
          }
          .totals-row td {
            font-weight: bold !important;
          }
        `}</style>





        {totals.netSettlement <= 0 && (
          <Text type="danger" style={{ display: 'block', marginBottom: '16px' }}>
            <ExclamationCircleOutlined style={{ marginRight: 6 }} />
            {intl.formatMessage({ id: 'settlement_NetSettlementZeroOrNegative' })}
          </Text>
        )}

      </Card>
    </div>
  );
};

export default Step2TransactionSummary;
